import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { User } from '../models/user';
import { UserApiService } from '../services/api/user.api.service';
import { CrudService } from '../services/crud.service';
import { DetailView } from '../models/detail-view';
import { DetailViewModels } from '../constants/detail-view-models';
import { filter, take, map } from 'rxjs/operators';
import { PhoneNumberPipe } from '../pipes/phone-number.pipe';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../services/user.service';
import { FeatureFlagService } from '../services/feature-flag.service';

@Component({
  selector: 'sa-driver-settings',
  templateUrl: './driver-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  providers: [PhoneNumberPipe],
})
export class DriverSettingsComponent implements OnInit {
  displayedColumns = ['userName', 'phone', 'pin', 'accountName', 'cdl', 'action'];
  dataSource: MatTableDataSource<User> = new MatTableDataSource();

  detailView: DetailView = {
    open: false,
    modelName: null,
    model: null,
  };

  constructor(
    private userApiService: UserApiService,
    private crudService: CrudService,
    public userService: UserService,
    public featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.crudService.httpClientReady.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.userApiService
        .getDrivers()
        .pipe(
          map((data) => {
            data.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            return data;
          }),
        )
        .subscribe((data) => {
          this.dataSource = new MatTableDataSource(data);
        });
    });
  }

  sortTable(event) {
    switch (event.active) {
      case 'userName':
        const sortedName = this.dataSource.data.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        if (event.direction === 'desc') {
          sortedName.reverse();
        }
        this.dataSource.data = sortedName;
        break;
      case 'phone':
        const sortedPhone = this.dataSource.data.sort((a, b) => {
          return +a.phone - +b.phone;
        });
        if (event.direction === 'desc') {
          sortedPhone.reverse();
        }
        this.dataSource.data = sortedPhone;
        break;
    }
  }

  openUserDetailView(user: User) {
    this.detailView.open = true;
    this.detailView.modelName = DetailViewModels.driverProfile;
    this.detailView.model = user;
  }

  closeUserDetailView() {
    this.detailView.open = false;
    this.detailView.modelName = null;
    this.detailView.model = null;
  }

  userUpdated(user: User) {
    this.loadData();
  }
}
